package org.example.project.dashboard

import androidx.compose.runtime.Composable
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
internal fun DashboardQuickbar(
    visiblePinnedScreens: List<String>,
    selectedKey: String,
    allScreens: List<All>,
    quickNavOffset: Int,
    quickNavMaxOffset: Int,
    contentLeftOffsetPx: Double,
    leftReservePx: Int = 0,
    rightReservePx: Int = 0,
    onQuickNavLeft: () -> Unit,
    onQuickNavRight: () -> Unit,
    onSelect: (String) -> Unit,
    onUnpin: (String) -> Unit,
    canGoLeft: Boolean = quickNavOffset > 0,
    canGoRight: Boolean = quickNavOffset < quickNavMaxOffset
) {
    Div({
        classes(DashboardStyles.quickBar)
        style {
            left((contentLeftOffsetPx + leftReservePx).px)
            right((ContentOffset.RIGHT.value + rightReservePx).px)
        }
    }) {
        Div({ classes(DashboardStyles.quickPager) }) {
            val showQuickNavArrows = quickNavMaxOffset > 0

            if (showQuickNavArrows) {
                Div({
                    classes(DashboardStyles.quickNavArrow, DashboardStyles.quickNavArrowLeft)
                    if (!canGoLeft) classes(DashboardStyles.quickNavArrowDisabled)
                    onClick {
                        if (canGoLeft) onQuickNavLeft()
                    }
                }) {
                    Img("images/left.svg") {
                        classes(DashboardStyles.quickNavArrowIcon)
                    }
                }
            }

            Div({ classes(DashboardStyles.quickItemsViewport) }) {
                Div({ classes(DashboardStyles.quickItems) }) {
                    visiblePinnedScreens.forEachIndexed { index, key ->
                        val screen = allScreens.firstOrNull { it.key == key } ?: return@forEachIndexed
                        Div({
                            classes(DashboardStyles.quickItem)
                            onClick { onSelect(key) }
                        }) {
                            Span({
                                style {
                                    color(DashboardTheme.TEXT_LIGHT)
                                    if (key == selectedKey) {
                                        fontWeight("700")
                                        property("border-bottom", "2px solid ${DashboardTheme.ACCENT}")
                                    } else {
                                        property("border-bottom", "2px solid transparent")
                                    }
                                }
                            }) { Text(screen.label) }

                            Img("images/miniclose.svg") {
                                style {
                                    width(14.px)
                                    height(14.px)
                                    marginLeft(10.px)
                                    cursor("pointer")
                                }
                                onClick { event ->
                                    event.stopPropagation()
                                    onUnpin(key)
                                }
                            }
                        }
                        if (index < visiblePinnedScreens.lastIndex) {
                            Div({ classes(DashboardStyles.quickDivider) })
                        }
                    }
                }
            }

            if (showQuickNavArrows) {
                Div({
                    classes(DashboardStyles.quickNavArrow, DashboardStyles.quickNavArrowRight)
                    if (!canGoRight) classes(DashboardStyles.quickNavArrowDisabled)
                    onClick {
                        if (canGoRight) onQuickNavRight()
                    }
                }) {
                    Img("images/right.svg") {
                        classes(DashboardStyles.quickNavArrowIcon)
                    }
                }
            }
        }
    }
}
